import { Injectable, inject } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { TranslocoService } from '@jsverse/transloco';
import { ToasterType } from '../types/toaster.interface';

const DEFAULT_TOASTER_SCOPE = 'coreData';

@Injectable()
export class CustomToasterService {
  private toastrService = inject(ToastrService);
  private translocoService = inject(TranslocoService);

  success(messageKey: string, scope: string = DEFAULT_TOASTER_SCOPE) {
    return this.showMessage('success', messageKey, scope);
  }

  error(messageKey: string, scope: string = DEFAULT_TOASTER_SCOPE) {
    return this.showMessage('error', messageKey, scope);
  }

  warning(messageKey: string, scope: string = DEFAULT_TOASTER_SCOPE) {
    return this.showMessage('warning', messageKey, scope);
  }

  info(messageKey: string, scope: string = DEFAULT_TOASTER_SCOPE) {
    return this.showMessage('info', messageKey, scope);
  }

  private showMessage(type: ToasterType, messageKey: string, scope: string) {
    const message = this.translocoService.translate(messageKey, {}, scope);
    const translatedType = this.translocoService.translate(
      `toastrType.${type}`,
      {},
      scope,
    );
    return this.toastrService[type](message, translatedType);
  }
}
